/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'

// Routes
import Login from '../pages/auth/Login.vue'
import Dashboard from "../views/Dashboard";
import Users from "../pages/users/Users";
import CbActivities from "../pages/cb/activities/CbActivities";
import CbHelpProviders from "../pages/cb/helpProviders/CbHelpProviders";
import CbHelpTypes from "../pages/cb/helpTypes/CbHelpTypes";
import CbHelpUserTypes from "../pages/cb/helpUserTypes/CbHelpUserTypes";
import CbHelpReceivers from "../pages/cb/helpReceivers/CbHelpReceivers";
import UserProfile from "../views/UserProfile";
import CbHelpGoals from "../pages/cb/helpGoals/CbHelpGoals";
import CbHelpInstruments from "../pages/cb/helpInstruments/CbHelpInstruments";
import CbHelpStatuses from "../pages/cb/helpStatuses/CbHelpStatuses";
import CbHelpSubGoals from "../pages/cb/helpSubGoals/CbHelpSubGoals";
import CbAgencyDecisions from "../pages/cb/agencyDecisions/CbAgencyDecisions";
import CbHelpMeasures from "../pages/cb/helpMeasures/CbHelpMeasures";
import CbProviderDecisions from "../pages/cb/providerDecisions/CbProviderDecisions";
import HelpRegistriesDeMinimis from "../pages/helpRegistries/deMinimis/HelpRegistriesDeMinimis";
import HelpRegistriesCovid from "../pages/helpRegistries/covid/HelpRegistriesCovid";
import HelpRegistriesGeneral from "../pages/helpRegistries/general/HelpRegistriesGeneral";
import HelpProviderHelpRegistryCovidAccepted
  from "../pages/helpProviderHelpRegistriesPages/covid/HelpProviderHelpRegistryCovidAccepted";
import HelpProviderHelpRegistryCovidInserted
  from "../pages/helpProviderHelpRegistriesPages/covid/HelpProviderHelpRegistryCovidInserted";
import HelpProviderHelpRegistryCovidReturned
  from "../pages/helpProviderHelpRegistriesPages/covid/HelpProviderHelpRegistryCovidReturned";
import HelpProviderHelpRegistryDeMinimisAccepted
  from "../pages/helpProviderHelpRegistriesPages/deMinimis/HelpProviderHelpRegistryDeMinimisAccepted";
import HelpProviderHelpRegistryDeMinimisInserted
  from "../pages/helpProviderHelpRegistriesPages/deMinimis/HelpProviderHelpRegistryDeMinimisInserted";
import HelpProviderHelpRegistryDeMinimisReturned
  from "../pages/helpProviderHelpRegistriesPages/deMinimis/HelpProviderHelpRegistryDeMinimisReturned";
import HelpProviderHelpRegistryGeneralAccepted
  from "../pages/helpProviderHelpRegistriesPages/general/HelpProviderHelpRegistryGeneralAccepted";
import HelpProviderHelpRegistryGeneralInserted
  from "../pages/helpProviderHelpRegistriesPages/general/HelpProviderHelpRegistryGeneralInserted";
import HelpProviderHelpRegistryGeneralReturned
  from "../pages/helpProviderHelpRegistriesPages/general/HelpProviderHelpRegistryGeneralReturned";
import HelpRegistriesCovidPublic from "../pages/helpRegistries/covid/HelpRegistriesCovidPublic";
import DashboardPublic from "../views/DashboardPublic";
import HelpRegistriesDeMinimisPublic from "../pages/helpRegistries/deMinimis/HelpRegistriesDeMinimisPublic";
import HelpRegistriesGeneralPublic from "../pages/helpRegistries/general/HelpRegistriesGeneralPublic";
import NotFound from "../views/NotFound";
import HelpRegistriesCovidReport from "../pages/helpRegistries/covid/HelpRegistriesCovidReport";
import HelpProviderHelpRegistryReturnedAccepted
  from "../pages/helpProviderHelpRegistriesPages/returned/HelpProviderHelpRegistryReturnedAccepted";
import HelpProviderHelpRegistryReturnedInserted
  from "../pages/helpProviderHelpRegistriesPages/returned/HelpProviderHelpRegistryReturnedInserted";
import HelpProviderHelpRegistryReturnedReturned
  from "../pages/helpProviderHelpRegistriesPages/returned/HelpProviderHelpRegistryReturnedReturned";
import HelpRegistriesReturnedPublic from "../pages/helpRegistries/returned/HelpRegistriesReturnedPublic";
import HelpRegistriesGeneralReport from "../pages/helpRegistries/general/HelpRegistriesGeneralReport";
import HelpRegistriesDeMinimisReport from "../pages/helpRegistries/deMinimis/HelpRegistriesDeMinimisReport";
import HelpRegistriesReturnedReport from "../pages/helpRegistries/returned/HelpRegistriesReturnedReport";
import HelpRegistriesCovidOffLimits from "../pages/helpRegistries/covid/HelpRegistriesCovidOffLimits";
import HelpRegistriesDeMinimisOffLimits from "../pages/helpRegistries/deMinimis/HelpRegistriesDeMinimisOffLimits";


Vue.use(Router)

function routes() {
  return [
    //NOT FOUND
    { path: "*", name: 'NotFound', component: NotFound, meta: {forAuth: false}},
    //PUBLIC ROUTES
    {path: '/', name: 'DashboardPublic', component: DashboardPublic, meta: {forAuth: false}},
    {path: '/public/covid', name: 'HelpRegistriesCovidPublic', component: HelpRegistriesCovidPublic, meta: {forAuth: false}},
    {path: '/public/de_minimis', name: 'HelpRegistriesDeMinimisPublic', component: HelpRegistriesDeMinimisPublic, meta: {forAuth: false}},
    {path: '/public/general', name: 'HelpRegistriesGeneralPublic', component: HelpRegistriesGeneralPublic, meta: {forAuth: false}},
    {path: '/public/returned', name: 'HelpRegistriesReturnedPublic', component: HelpRegistriesReturnedPublic, meta: {forAuth: false}},



    {path: '/login', name: 'Login', component: Login, meta: {forVisitors: true}},
    {path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: {forAuth: true}},
    {path: '/user-profile', name: 'User', component: UserProfile, meta: {forAuth: true}},
    {path: '/management/users', name: 'Users', component: Users, meta: {forAuth: true}},
    {path: '/management/cb_activities', name: 'CbActivities', component: CbActivities, meta: {forAuth: true}},
    {path: '/management/cb_agency_decisions', name: 'CbAgencyDecisions', component: CbAgencyDecisions, meta: {forAuth: true}},
    {path: '/management/cb_help_goals', name: 'CbHelpGoals', component: CbHelpGoals, meta: {forAuth: true}},
    {path: '/management/cb_help_instruments', name: 'CbHelpInstruments', component: CbHelpInstruments, meta: {forAuth: true}},
    {path: '/management/cb_help_measures', name: 'CbHelpMeasures', component: CbHelpMeasures, meta: {forAuth: true}},
    {path: '/management/cb_help_providers', name: 'CbHelpProviders', component: CbHelpProviders, meta: {forAuth: true}},
    {path: '/management/cb_help_receivers', name: 'CbHelpReceivers', component: CbHelpReceivers, meta: {forAuth: true}},
    {path: '/management/cb_help_statuses', name: 'CbHelpStatuses', component: CbHelpStatuses, meta: {forAuth: true}},
    {path: '/management/cb_help_sub_goals', name: 'CbHelpSubGoals', component: CbHelpSubGoals, meta: {forAuth: true}},
    {path: '/management/cb_help_types', name: 'CbHelpTypes', component: CbHelpTypes, meta: {forAuth: true}},
    {path: '/management/cb_help_user_types', name: 'CbHelpUserTypes', component: CbHelpUserTypes, meta: {forAuth: true}},
    {path: '/management/cb_provider_decisions', name: 'CbProviderDecisions', component: CbProviderDecisions, meta: {forAuth: true}},

    // {path: '/help_registries/de_minimis', name: 'HelpRegistriesDeMinimis', component: HelpRegistriesDeMinimis, meta: {forAuth: true}},
    // {path: '/help_registries/covid', name: 'HelpRegistriesCovid', component: HelpRegistriesCovid, meta: {forAuth: true}},
    // {path: '/help_registries/general', name: 'HelpRegistriesGeneral', component: HelpRegistriesGeneral, meta: {forAuth: true}},


    //COVID
    {path: '/help_registries/covid/accepted', name: 'HelpProviderHelpRegistryCovidAccepted', component: HelpProviderHelpRegistryCovidAccepted, meta: {forAuth: true}},
    {path: '/help_registries/covid/inserted', name: 'HelpProviderHelpRegistryCovidInserted', component: HelpProviderHelpRegistryCovidInserted, meta: {forAuth: true}},
    {path: '/help_registries/covid/returned', name: 'HelpProviderHelpRegistryCovidReturned', component: HelpProviderHelpRegistryCovidReturned, meta: {forAuth: true}},
    {path: '/help_registries/covid/off_limits', name: 'HelpRegistriesCovidOffLimits', component: HelpRegistriesCovidOffLimits, meta: {forAuth: true}},
    {path: '/help_registries/covid/report', name: 'HelpRegistriesCovidReport', component: HelpRegistriesCovidReport, meta: {forAuth: true}},

    //DEMINIMIS
    {path: '/help_registries/de_minimis/accepted', name: 'HelpProviderHelpRegistryDeMinimisAccepted', component: HelpProviderHelpRegistryDeMinimisAccepted, meta: {forAuth: true}},
    {path: '/help_registries/de_minimis/inserted', name: 'HelpProviderHelpRegistryDeMinimisInserted', component: HelpProviderHelpRegistryDeMinimisInserted, meta: {forAuth: true}},
    {path: '/help_registries/de_minimis/returned', name: 'HelpProviderHelpRegistryDeMinimisReturned', component: HelpProviderHelpRegistryDeMinimisReturned, meta: {forAuth: true}},
    {path: '/help_registries/de_minimis/off_limits', name: 'HelpRegistriesDeMinimisOffLimits', component: HelpRegistriesDeMinimisOffLimits, meta: {forAuth: true}},
    {path: '/help_registries/de_minimis/report', name: 'HelpRegistriesDeMinimisReport', component: HelpRegistriesDeMinimisReport, meta: {forAuth: true}},

    //GENERAL
    {path: '/help_registries/general/accepted', name: 'HelpProviderHelpRegistryGeneralAccepted', component: HelpProviderHelpRegistryGeneralAccepted, meta: {forAuth: true}},
    {path: '/help_registries/general/inserted', name: 'HelpProviderHelpRegistryGeneralInserted', component: HelpProviderHelpRegistryGeneralInserted, meta: {forAuth: true}},
    {path: '/help_registries/general/returned', name: 'HelpProviderHelpRegistryGeneralReturned', component: HelpProviderHelpRegistryGeneralReturned, meta: {forAuth: true}},
    {path: '/help_registries/general/report', name: 'HelpRegistriesGeneralReport', component: HelpRegistriesGeneralReport, meta: {forAuth: true}},

    //RETURNED
    {path: '/help_registries/returned/accepted', name: 'HelpProviderHelpRegistryReturnedAccepted', component: HelpProviderHelpRegistryReturnedAccepted, meta: {forAuth: true}},
    {path: '/help_registries/returned/inserted', name: 'HelpProviderHelpRegistryReturnedInserted', component: HelpProviderHelpRegistryReturnedInserted, meta: {forAuth: true}},
    {path: '/help_registries/returned/returned', name: 'HelpProviderHelpRegistryReturnedReturned', component: HelpProviderHelpRegistryReturnedReturned, meta: {forAuth: true}},
    {path: '/help_registries/returned/report', name: 'HelpRegistriesReturnedReport', component: HelpRegistriesReturnedReport, meta: {forAuth: true}},



    // {path: '/table-list', name: 'Table List', component: TableList, meta: {forAuth: true}},
    // {path: '/typography', name: 'Typography', component: Typography, meta: {forAuth: true}},
    // {path: '/icons', name: 'Icons', component: Icons, meta: {forAuth: true}},
    // {path: '/maps', name: 'Maps', component: Maps, meta: {forAuth: true}},
    // {path: '/notifications', name: 'Notifications', component: Notifications, meta: {forAuth: true}},
    // {path: '/cities', name: 'Gradovi', component: Cities, meta: {forAuth: true}},
    // {path: '/technical_support', name: 'technical_support', component: TechnicalSupport, meta: {forAuth: true}},
    // {path: '/sliders', name: 'Slajderi', component: Sliders, meta: {forAuth: true}},
    // {path: '/categories', name: 'Kategorije', component: Categories, meta: {forAuth: true}},
    // {path: '/countries', name: 'Drzave', component: Countries, meta: {forAuth: true}},
    // {path: '/campaigns', name: 'Kampanje', component: Campaigns, meta: {forAuth: true}},
    // {path: '/products', name: 'Proizvodi', component: Products, meta: {forAuth: true}},
    // {path: '/partners', name: 'Partneri', component: Partners, meta: {forAuth: true}},
    // {path: '/customerService', name: 'Podrska', component: CustomerService, meta: {forAuth: true}},
    // {path: '/stores', name: 'Prodavnice', component: Stores, meta: {forAuth: true}},
  ];
}

export default new Router({
  mode: 'history',
  routes: routes()
});
